/** User-facing copy for the Chairside Help Assistant. */

export const HELP_OFF_TOPIC_RESPONSE = `Please ask a Chairside-related question.

I can help with appointments, consultations, recare, pipeline, calling, settings, and other features in this app. Try asking how to sync patients, use the lead queue, or manage recare.`;

export const HELP_UNAVAILABLE_RESPONSE = `I'm temporarily unavailable. Please try again in a moment.

If you need human support, open [[Support Tickets|/tickets]] from the sidebar.`;

// Only obvious greetings / social / clearly-unrelated chatter is treated as
// off-topic and answered locally. EVERY other message is forwarded to the
// assistant, which has the full Chairside knowledge base (all modules, all
// roles) in its system prompt and will answer it — or politely decline if it is
// genuinely unrelated. We do NOT keyword-gate real questions anymore, because a
// fixed keyword list silently rejected many valid app questions.
const OFF_TOPIC_PATTERNS = [
  /^(hi+|hey+|hello+|yo+|sup+|howdy)\b[!.,?\s]*$/i,
  /^how are you\b/i,
  /^what'?s up\b/i,
  /^thanks?[!.,?\s]*$/i,
  /^thank you[!.,?\s]*$/i,
  /^ok(ay)?[!.,?\s]*$/i,
  /^who are you\b/i,
  /^tell me (a )?joke\b/i,
  /^weather\b/i,
  /^are you (a )?(bot|ai|human)\b/i,
];

export function isChairsideAppQuestion(text) {
  const t = String(text || "").trim().toLowerCase();
  if (!t) return false;
  // Block only obvious social/greeting messages; let everything else through.
  return !OFF_TOPIC_PATTERNS.some((p) => p.test(t));
}

export const SUGGESTED_QUESTIONS = [
  "How do I take a consultation?",
  "How do I sync patients from the PMS?",
  "How does the recare dashboard work?",
  "How do I use the lead queue?",
  "Where do I manage pipeline stages?",
  "How do I open a support ticket?",
];
